import { useEffect, useRef, useState } from "react";
import {
  BUSINESS_COUNTRY_PRESETS_SORTED,
  getCountryPreset,
} from "../constants/businessCountryPresets";
import { countryFlagImageUrl } from "../utils/countryFlag";

export function CountryFlag({ countryCode, className = "signup-flag-img" }) {
  const src = countryFlagImageUrl(countryCode, 40);
  const preset = getCountryPreset(countryCode);
  if (!src) {
    return <span className="signup-flag-emoji">{preset.flagEmoji}</span>;
  }
  return (
    <img
      className={className}
      src={src}
      alt=""
      width={22}
      height={16}
      loading="lazy"
    />
  );
}

export function CountryPicker({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = getCountryPreset(value);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="signup-input-wrap signup-select-wrap signup-country-field" ref={rootRef}>
      <i className="fa-solid fa-globe signup-field-icon" aria-hidden="true" />
      <button
        type="button"
        className="signup-country-trigger"
        onClick={() => {
          if (!disabled) setOpen((v) => !v);
        }}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <CountryFlag countryCode={selected.countryCode} />
        <span className="signup-country-trigger-label">{selected.label}</span>
      </button>
      <i className="fa-solid fa-chevron-down signup-select-caret" aria-hidden="true" />

      {open ? (
        <div className="signup-country-dropdown" role="listbox">
          {BUSINESS_COUNTRY_PRESETS_SORTED.map((p) => {
            const active = p.countryCode === selected.countryCode;
            return (
              <button
                key={p.countryCode}
                type="button"
                role="option"
                aria-selected={active}
                className={`signup-country-row${active ? " is-active" : ""}`}
                onClick={() => {
                  onChange(p.countryCode);
                  setOpen(false);
                }}
              >
                <CountryFlag countryCode={p.countryCode} />
                <span className="signup-country-row-label">{p.label}</span>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
